import { render, staticRenderFns } from "./gl.vue?vue&type=template&id=9c56486e&scoped=true&"
import script from "./gl.vue?vue&type=script&lang=js&"
export * from "./gl.vue?vue&type=script&lang=js&"
import style0 from "./gl.vue?vue&type=style&index=0&id=9c56486e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c56486e",
  null
  
)

export default component.exports